import { apiClient } from '../../api/client';
import { endpoints } from '../../api/endpoints';
import type { BlogPostListResponse } from '../../types/api';
import type { BlogPost, BlogPostInput } from '../../types';

function unwrapList(response: BlogPostListResponse | BlogPost[]): BlogPost[] {
  return Array.isArray(response) ? response : response.blogPosts;
}

export async function httpFetchPublishedBlogPosts(): Promise<BlogPost[]> {
  const response = await apiClient<BlogPostListResponse | BlogPost[]>(endpoints.blogPosts.list, {
    auth: false,
  });
  return unwrapList(response);
}

export async function httpFetchAllBlogPosts(): Promise<BlogPost[]> {
  const response = await apiClient<BlogPostListResponse | BlogPost[]>(endpoints.blogPosts.manageList);
  return unwrapList(response);
}

export async function httpGetBlogPost(id: number): Promise<BlogPost> {
  return apiClient<BlogPost>(endpoints.blogPosts.manageDetail(id));
}

export async function httpGetBlogPostBySlug(slug: string): Promise<BlogPost> {
  return apiClient<BlogPost>(endpoints.blogPosts.bySlug(slug), { auth: false });
}

export async function httpCreateBlogPost(input: BlogPostInput): Promise<BlogPost> {
  return apiClient<BlogPost>(endpoints.blogPosts.create, {
    method: 'POST',
    body: input,
  });
}

export async function httpUpdateBlogPost(id: number, input: BlogPostInput): Promise<BlogPost> {
  return apiClient<BlogPost>(endpoints.blogPosts.update(id), {
    method: 'PUT',
    body: input,
  });
}

export async function httpDeleteBlogPost(id: number): Promise<void> {
  await apiClient<void>(endpoints.blogPosts.delete(id), { method: 'DELETE' });
}

export async function httpUploadBlogMedia(file: File): Promise<string> {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient<{ url: string }>(endpoints.blogPosts.uploadMedia, {
    method: 'POST',
    body: formData,
  });

  return response.url;
}
